import React from 'react';
import { StatsCards } from '../../../../Components/StatsCards/StatsCards';
import { ProgressOverview } from '../../../../Components/ProgressOverview/ProgressOverview';
import { useLeaderboardSummary } from '../../../../hooks/useLeaderboardSummary';
import { LeaderboardEvent } from '../../../../api/leaderboard-events';
import './AdminResultsSidebar.scss';

interface AdminResultsSidebarProps {
  selectedEvent?: LeaderboardEvent | null;
}

export const ResultsSidebar: React.FC<AdminResultsSidebarProps> = ({ selectedEvent }) => {
  const { summary } = useLeaderboardSummary(selectedEvent?.id);

  const progressData =
    summary && selectedEvent
      ? [
          {
            label: 'Total Hours',
            value: summary.totalHours,
            max: selectedEvent.milestone,
          },
          {
            label: 'Total Reviews',
            value: summary.reviewsCount,
            max: summary.reviewMilestone,
          },
        ]
      : undefined;
  return (
    <div className="results-sidebar">
      <ProgressOverview data={progressData} />
      <StatsCards summary={summary} />
    </div>
  );
};
